module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargadorDerecha-dd-8bc17114.png";